import LoadingSpinner from '@/assets/icons/loading-spinner'

type LoaderProps = {
  message?: string
  size?: 'sm' | 'md' | 'lg'
  fullScreen?: boolean
}

const sizeClasses: Record<NonNullable<LoaderProps['size']>, string> = {
  sm: 'gap-2 text-body-sm',
  md: 'gap-2.5 text-body',
  lg: 'gap-3 text-body-lg',
}

export const Loader = ({
  message,
  size = 'md',
  fullScreen = false,
}: LoaderProps) => {
  const content = (
    <div
      className={`flex items-center justify-center text-(--color-text-muted) ${sizeClasses[size]}`}
    >
      <LoadingSpinner />
      {message && <span>{message}</span>}
    </div>
  )

  if (fullScreen) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-(--color-surface)/80">
        {content}
      </div>
    )
  }

  return content
}

export default Loader
